// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--Mw2yE","invisible":"a2c79c7e7d--invisible--zmoKl","tab":"a2c79c7e7d--tab--OB07b","active":"a2c79c7e7d--active--tboei"};